<template>
  <v-card
    outlined
    class="rounded-xl"
  >
    <v-card-title
      class="text-subtitle-1 font-weight-bold text-truncate d-inline-block py-4 d-flex flex-row align-center"
    >
      Еденицы измерения достижения
      <v-spacer/>
      <v-icon :color="$store.state.achievement.side_color">
        fa fa-question-circle
      </v-icon>
    </v-card-title>
    <v-divider/>
    <v-card-text class="scroll" style="max-height: 80vh">
      <v-row no-gutters>
        <v-scroll-y-transition
          class="py-0"
          tag="div"
          leave-absolute
          style="width: 100%"
          group
        >
          <v-col cols="12" v-for="(unit, index) in achievementKindUnits" :key="keyVForUnit(unit)">
            <v-card min-height="100%" outlined class="rounded-xl">
              <v-card-title
                  class="text-subtitle-1 font-weight-bold text-truncate d-inline-block py-2 d-flex"
              >
                {{ titleCardUnit(unit.name) }}
                <v-spacer/>
                <v-icon
                  small
                  :color="$store.state.achievement.btn_color"
                  @click="deleteUnitWithAchievement(index)"
                >
                  fa fa-trash
                </v-icon>
                <div class="mx-1" />
                <v-icon
                    small
                    :color="$store.state.achievement.btn_color"
                    @click="toggleHiddenAchievementUnit(unit.id)"
                    v-show="!isNew(unit)"
                >
                  {{!unit.is_hidden ? "fa fa-eye" : "fa-eye-slash"}}
                </v-icon>
              </v-card-title>
              <v-divider/>
              <v-card-text style="max-height: 800px" class="overflow-auto">
                <achievement-kind-unit-text-field :index="index" :achievement-unit="unit"/>
                <section-edit-subunit :unit="unit" :index-unit="index"/>
              </v-card-text>
            </v-card>
          </v-col>
        </v-scroll-y-transition>
        <v-col cols="12" style="height: 100%">
          <add-card :body_text="'Добавить критерий оценивания'"
                    :min_height="'44px'"
                    class="mt-3"
                    @add="pushUnitWithAchievement()"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import AddCard from "../../Cards/AddCard";
import AchievementKindUnitTextField from "../FormAdminAchievementKind/AchievementKindUnitTextField";
import SectionEditSubunit from "./SectionEditSubunit";
import {createHelpers} from "vuex-map-fields";

export default {
  name: "SectionEditUnit",

  components: {
    AddCard,
    AchievementKindUnitTextField,
    SectionEditSubunit,
  },

  computed: {
    ...mapState({
      achievementTypeId: state => state.achievement_kind.payload.prtf_achievement_type_id,
      units: state => state.achievement_kind.payload.prtf_achievement_units_attributes,
    }),

    achievementKindUnits() {
      return _.filter(this.units, (unit)=> !_.has(unit,"_destroy"));
    },

  },

  methods: {
    ...mapMutations({
      pushUnitWithAchievement: 'achievement_kind/pushUnitWithAchievement',
      deleteUnitWithAchievement: 'achievement_kind/deleteUnitWithAchievement',
    }),
    ...mapActions({
      toggleHiddenAchievementUnit: 'achievement_kind/toggleHiddenAchievementUnit',
    }),

    titleCardUnit(name) {
      if (!name.length) return "Ед. измерения"
      else return name
    },

    keyVForUnit(unit) {
      if (this.isNew(unit)) return `unit-${unit?._index}`
      else return unit.id
    },

    isNew(unit) {
      return unit?.id == null
    }

  },
}
</script>

<style scoped>
.scroll {
  overflow-y: scroll
}
</style>